import { CloseDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('CloseDialog')
export class CloseDialogNodeSchemaProvider extends SchemaProvider<CloseDialogWorkflowNode> {}
